import React, { Component } from 'react'

export default class extends Component {
  render() {
    return (
      <div className="app-grid-menu">
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AppGridLayout/AppGridMenu.tsx